module.exports = __webpack_public_path__ + "static/ghetto-bros-left-7c33e8605bd7440dd5a4c766ddc7f1e6.png";